import type { RestaurantProfileDto } from '../models/restaurant-api.model';

/** Bundled under `src/assets` → served as `/assets/kanyar_bufe_logo.jpg` when `angular.json` includes `src/assets`. */
export const DEFAULT_LOCAL_LOGO_PATH = 'assets/kanyar_bufe_logo.jpg';

export function normalizeLogoUrl(url: string): string {
  const u = url.trim();
  if (
    u.startsWith('http://') ||
    u.startsWith('https://') ||
    u.startsWith('data:') ||
    u.startsWith('/') ||
    u.startsWith('assets/')
  ) {
    return u;
  }
  return `assets/${u.replace(/^\.\//, '')}`;
}

export function resolveRestaurantLogoUrl(profile: RestaurantProfileDto | null): string {
  const fromApi = profile?.logoUrl?.trim();
  if (!fromApi) {
    return DEFAULT_LOCAL_LOGO_PATH;
  }
  return normalizeLogoUrl(fromApi);
}
